export default __webpack_public_path__ + "sealed_hembar.png";